<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="selectedValue"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="selectedValue"
        :label="label"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        :rules="rules"
        dense
        :disabled="disabled"
      />
    </template>

    <v-date-picker
      v-model="selectedValue"
      no-title
      scrollable
      :max="date_max"
      :min="date_min"
      @input="handleSelectDate"
    >
      <v-spacer />

      <BtnCircle
        tLabel="Cancelar"
        tPosition="top"
        icon="mdi-close"
        color="default"
        size="x-small"
        :click="handleCancel"
      />

      <BtnCircle
        v-if="enableClean"
        tLabel="Limpiar"
        tPosition="top"
        icon="mdi-eraser"
        color="secondary"
        size="x-small"
        :click="handleClean"
      />
    </v-date-picker>
  </v-menu>
</template>

<script>
import BtnCircle from "./BtnCircle.vue";

export default {
  components: {
    BtnCircle,
  },
  props: ["label", "model", "rules"],
  data() {
    return {
      menu: false,
      enableClean: typeof this.$attrs.clean !== "undefined",
      disabled:
        typeof this.$attrs.disabled !== "undefined"
          ? this.$attrs.disabled
          : false,
      enableAfterDate: typeof this.$attrs.enableAfterDate !== "undefined",
      enableAllDate: typeof this.$attrs.all_date !== "undefined",
      oneWeek: typeof this.$attrs.oneWeek !== "undefined",
      date_max: "",
      date_min: "",
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.getValidDate(this.model);
      },
      set(new_value) {
        this.$emit("update:model", this.getValidDate(new_value));
      },
    },
  },
  methods: {
    getValidDate(value) {
      if (!this.isValidDate(value)) {
        return null;
      }

      return value;
    },
    isValidDate(value) {
      if (typeof value !== "string") {
        return false;
      }

      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return false;
      }

      if (value === "0000-00-00") {
        return false;
      }

      const parts = value.split("-");
      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const day = Number(parts[2]);
      const date = new Date(year, month - 1, day);

      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      );
    },
    handleCancel() {
      this.menu = false;
    },
    handleClean() {
      this.$refs.menu.save(null);
    },
    handleSelectDate(value) {
      this.$refs.menu.save(value);
    },
  },
  mounted() {
    this.date_min = "";
    this.date_max = "";

    const old = "1900-01-01";

    if (!this.enableAllDate) {
      const now = new Date(
        Date.now() -
          (this.enableAfterDate ? 0 : new Date().getTimezoneOffset() * 60000),
      )
        .toISOString()
        .substr(0, 10);

      this.date_min = this.enableAfterDate ? now : old;
      this.date_max = this.enableAfterDate ? "" : now;
    }

    if (this.oneWeek) {
      const now = new Date(Date.now() + 3600 * 1000 * 24 * 14)
        .toISOString()
        .substr(0, 10);

      this.date_min = old;
      this.date_max = now;
    }
  },
};
</script>
